import { FeatureData } from '../../components/ui/feature-section-with-hoover-effect';
import {
  IconAffiliate,
  IconBinaryTree2,
  IconUserShield,
  IconBrandAzure,
} from '@tabler/icons-react';

const formationADFeatures: FeatureData[] = [
  {
    title: 'formationAD.features.1.title',
    description: 'formationAD.features.1.description',
    icon: <IconAffiliate size={24} />,
    key: "formationAD.features.1",
  },
  {
    title: 'formationAD.features.2.title',
    description: 'formationAD.features.2.description',
    icon: <IconBinaryTree2 size={24} />,
    key: 'formationAD.features.2'
  },
  {
    title: 'formationAD.features.3.title',
    description: 'formationAD.features.3.description',
    icon: <IconUserShield size={24} />,
    key: 'formationAD.features.3'
  },
  {
    title: 'formationAD.features.4.title',
    description: 'formationAD.features.4.description',
    icon: <IconBrandAzure size={24} />,
    key: 'formationAD.features.4'
  },
];

export default formationADFeatures; 